import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { SignOut, UserCircle, InstagramLogo } from "@phosphor-icons/react";

const IG_URL = "https://instagram.com/trainwithlucy";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-[#1F1812] border-b border-white/10" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
          <div className="w-10 h-10 rounded-full overflow-hidden border border-[#D4A574]/40 bg-white/5">
            <img src="https://customer-assets.emergentagent.com/job_fit-class-hub-2/artifacts/r8vouf7i_IMG_8619.jpeg" alt="Train With Lucy" className="w-full h-full object-cover" />
          </div>
          <span className="font-display text-xl sm:text-2xl tracking-widest leading-none">TRAIN<span className="text-[#D4A574]">WITH</span>LUCY</span>
        </Link>
        <nav className="flex items-center gap-7">
          <Link to="/classes" className="label-overline hover:text-white" data-testid="nav-classes">Classes</Link>
          <Link to="/subscribe" className="label-overline hover:text-white hidden sm:inline" data-testid="nav-subscribe">Subscribe</Link>
          <a href={IG_URL} target="_blank" rel="noopener noreferrer" className="text-zinc-400 hover:text-[#D4A574]" data-testid="nav-instagram" aria-label="Instagram">
            <InstagramLogo weight="duotone" size={20} />
          </a>
          {user ? (
            <>
              <Link to="/library" className="label-overline hover:text-white" data-testid="nav-library">Library</Link>
              {user.role === "admin" && (
                <Link to="/admin" className="label-overline text-[#D4A574] hover:text-white" data-testid="nav-admin">Admin</Link>
              )}
              <div className="flex items-center gap-3 pl-4 border-l border-white/10">
                <UserCircle size={20} className="text-zinc-400" />
                <span className="text-sm text-zinc-300 hidden sm:inline" data-testid="nav-user-name">{user.name}</span>
                <button onClick={() => { logout(); nav("/"); }} className="text-zinc-400 hover:text-white" data-testid="nav-logout-btn" aria-label="Logout">
                  <SignOut size={18} />
                </button>
              </div>
            </>
          ) : (
            <>
              <Link to="/login" className="label-overline hover:text-white" data-testid="nav-login">Login</Link>
              <Link to="/register" className="kinetic-btn text-xs" data-testid="nav-register">Join</Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
